/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import styles from './ReviewConfirmation.module.scss'
import BackNextButtonsGreen from 'shared/components/BackNextButtonsGreen.jsx'
import CasesListTable from '../../CasesList/components/CasesListTable'
import { postTransactionAction } from 'redux/reducers/apiReducers/postTransactionReducer'
import { screenLoadingAction } from 'redux/actions'
import { useLocation } from 'react-router'
import { useHistory } from 'react-router-dom'
import BackAnchor from '../../../../shared/components/BackAnchor'

const ReviewConfirmationView = ({ t, i18n, setIsError }) => {
  let history = useHistory()
  const location = useLocation()

  const [confirmChecked, setConfirmChecked] = useState(false)
  const [checkboxMessage, setCheckbocMessage] = useState(false)
  const [errMsg, setErrMsg] = useState('')
  const dispatch = useDispatch()

  const cases = useSelector((state) => state.app.cases)
  const emailAddress = useSelector((state) => state.app.emailAddress)

  const userIdentifier = useSelector((state) => state.register.uniqueID)

  const [fulfillmentStatusError, setFulfillmentStatusError] = useState()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const fulfillmentStatus = params.get('fulfillmentStatus')
    if (fulfillmentStatus === 'SENTFORPAYMENT') {
      setFulfillmentStatusError('review_confirmation.server_error')
    }
  }, [location])

  const getTransactionData = () => {
    try {
      let businessData = {}
      let caseInformation = {
        cases,
        emailAddress,
      }
      businessData['caseInformation'] = caseInformation
      let data = {}
      data['businessData'] = JSON.stringify(businessData)
      data['businessServiceType'] = 'PAYRESTITUTION'
      data['lang'] = i18n.language.toString()
      data['useridentifier'] = userIdentifier.toString()
      return data
    } catch (err) {
      console.log(err)
      throw err
    }
  }

  const confirmationClick = () => {
    try {
      if (confirmChecked) {
        setCheckbocMessage(false)
        dispatch(screenLoadingAction())
        dispatch(postTransactionAction(getTransactionData()))
          .then((res) => {
            let transId = res['data']['id']
            let uuid = res['data']['useridentifier']
            let paymentURL = `/services/transactionservice/api/nspayredirect?transId=${transId}&transOwner=${uuid}`
            dispatch(screenLoadingAction())
            window.location.assign(`${window.location.origin}${paymentURL}`)
          })
          .catch((e) => {
            dispatch(screenLoadingAction())
            console.log(e)
            setErrMsg('review_confirmation.server_error')
          })
      } else {
        setCheckbocMessage(true)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const contactInfoUrl = window.location.origin + `/${i18n.language}/contact-info`

  const editContactInfoOnClick = () => {
    window.open(contactInfoUrl, '_self')
  }

  const backNextProps = {
    prevText: t('review_confirmation.back'),
    prevURL: `/${i18n.language}${t('routes.contact_info')}`,
    nextText: t('review_confirmation.proceed_to_payment'),
  }

  const addAnotherCase = () => {
    localStorage.setItem('addAnotherCaseClicked', 'reviewConfirm')
    history.push(`/${i18n.language}/case-info`)
  }

  return (
    <div className="container">
      <BackAnchor />
      <div className="row">
        <div className="col-xs-12">
          <h1>{t('review_confirmation.review_summary')}</h1>
        </div>
      </div>
      <div className={styles['content_margin']}>
        <CasesListTable />
        <div className="row">
          <div className="col-xs-12 col-md-8">
            <button className={['btn-lg btn-default-transparent', styles['add_case_right']].join(' ')} onClick={addAnotherCase}>
              {t('review_confirmation.add_another_case')}
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h3 style={{ display: 'inline-block' }}>{t('review_confirmation.contact_information')}</h3>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <div>
            <span style={{ display: 'inline-block', 'margin-right': '10px' }}>{t('review_confirmation.email_address')}</span>
            <span className="ex1">{emailAddress}</span>
            <a
              href="#"
              className={[styles['edit_button_right']].join(' ')}
              value={t('review_confirmation.edit')}
              name={t('review_confirmation.edit')}
              onClick={editContactInfoOnClick}
            >
              {t('review_confirmation.edit')}
              <span className="ns-visually-hidden">(ouvre dans un nouvel onglet)</span>
            </a>
          </div>
        </div>
      </div>
      <div className={checkboxMessage && 'ns-form-group-message-error'}>
        <div className="row">
          <div className="col-xs-12 col-md-8">
            <h3>{t('review_confirmation.confirmation')}</h3>
            <p>{t('review_confirmation.please_verify')}</p>
            <p>{t('review_confirmation.your_confirmation')}</p>
            <ul style={{ marginBottom: checkboxMessage && '10px' }}>
              <li>{t('review_confirmation.you_consent_to')}</li>
              <li>
                {t('review_confirmation.you_are_in_agreement')}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={
                    i18n.language === 'en'
                      ? 'https://novascotia.ca/sns/services/help/terms-of-use.asp'
                      : 'https://novascotia.ca/sns/services/help/terms-of-use-fr.asp'
                  }
                >
                  {t('review_confirmation.terms_of_use')}
                </a>
                {t('review_confirmation.open_new_tab')}
                {t('review_confirmation.for_this_transaction')}
              </li>
            </ul>
          </div>
        </div>
        {checkboxMessage && (
          <div className="form-group has-error help-block" style={{ marginBottom: '15px' }}>
            <i
              style={{ margin: '3px 5px 0 0' }}
              className={['fa fa-exclamation-circle', styles['exclamation_color']].join(' ')}
              aria-hidden="true"
            ></i>{' '}
            {t('review_confirmation.confirm_check_error')}
          </div>
        )}
        {errMsg === '' ? null : (
          <div className={styles['error_message']}>
            <div className="form-group has-error">
              <div className="help-block">
                <i
                  className={['fa fa-exclamation-circle', styles['exclamation_position'], styles['exclamation_color']].join(' ')}
                  aria-hidden="true"
                />{' '}
                {t(errMsg)}
              </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="ns-checkboxes__item">
            <input
              class="ns-checkboxes__input"
              type="checkbox"
              id="ConfirmationCheckBox"
              value="confirm_check"
              onChange={(e) => {
                setConfirmChecked(e.currentTarget.checked)
              }}
              onBlur={() => {
                confirmChecked ? setCheckbocMessage(false) : setCheckbocMessage(true)
              }}
              checked={confirmChecked}
            />
            <label className="ns-label ns-checkboxes__label" htmlFor="ConfirmationCheckBox">
              <span className="ns-label-span">
                <b>{t('review_confirmation.yes_information_is_correct')}</b>
              </span>
            </label>
          </div>
        </div>
      </div>
      <div className={styles['error_margin']}>
        <BackNextButtonsGreen props={backNextProps} nextOnClick={confirmationClick} />
      </div>
    </div>
  )
}

export default withTranslation('common')(ReviewConfirmationView)
